$(function () {
    const CART_UPDATED = 'cart:updated';

    $('input.item-quantity').on('input', function (e) {
        const quantity = parseInt(e.target.value);
        const code = $(e.target).data('code');

        postToCart(
            JSON.stringify({
                isCheckout: true,
                items: {
                    [code]: { quantity }
                }
            })
        );
    });

    $('.remove-cart-item').click(function (e) {
        event.preventDefault();
        event.stopPropagation();

        const code = $(e.target).data('item-code');

        postToCart(
            JSON.stringify({
                isCheckout: true,
                items: {
                    [code]: { quantity: 0 }
                }
            })
        );
    });

    $('#add-cart-coupon-code').click(function (event) {
        event.preventDefault();
        event.stopPropagation();

        const code = $('#cart-coupon-code').val();

        $('#cart-coupon-code-error').hide();

        $.post({
            url: `/api/commerce/cart/coupon`,
            data: { couponCode: code }
        }).done((data) => {
            console.log('add-code', data);
            if (data.success) {
                $(document).trigger(CART_UPDATED, data.payload);
            } else {
                $('#cart-coupon-code-error').show();
            }
        });
    });

    $(document).on('click', '.remove-discount-code', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const code = event.currentTarget.value;

        $.ajax({
            method: 'delete',
            url: `/api/commerce/cart/coupon`,
            data: { couponCode: code }
        }).done((data) => {
            console.log('remove-code', data);
            $(document).trigger(CART_UPDATED, data.payload);
        });
    });

    // post cart updates
    const postToCart = (updateModel) => {
        $.post({
            url: `/api/commerce/cart`,
            data: updateModel,
            dataType: `json`,
            contentType: `application/json`
        }).done((data) => {
            $(document).trigger(CART_UPDATED, data.payload);
        });
    };

    $(document).on(CART_UPDATED, function (event, payload) {
        // Toggle discount data rows
        $('.cart-discount-row').toggleClass(
            'd-none',
            payload.subTotal === payload.subTotalInclDiscount
        );
    });

    $(document).on(CART_UPDATED, function (event, payload) {
        // Remove removed item items
        $('li.cart-item')
            .filter((_, li) => {
                const code = $(li).data('code');
                return !payload.items[code];
            })
            .remove();

        if ($('li.cart-item').length === 0) {
            location.reload(true);
        }
    });

    $(document).on(CART_UPDATED, function (event, payload) {
        // Update item subtotals on quantity change
        $('.item-subtotal').each((_, subtotal) => {
            const $subtotal = $(subtotal);
            const code = $subtotal.data('code');
            payload.items[code] && $subtotal.text(payload.items[code].totalPrice);
        });
    });

    $(document).on(CART_UPDATED, function (event, payload) {
        // Update order summary  on quantity change
        $('.cart-total-without-tax').text(payload.subTotal);
        $('.cart-tax').text(payload.taxes);
        $('.cart-discount').text(payload.discount);
        $('.cart-total-with-discount').text(payload.subTotalInclDiscount);
        $('.cart-total-with-tax').text(payload.total);
    });

    $(document).on(CART_UPDATED, function (event, payload) {
        // Update top right cart icon count
        $('.shopping-cart-icon__count').text(payload.totalCount);
    });

    $(document).on(CART_UPDATED, function (event, payload) {
        // Update discount codes
        const itemTemplate = (code) =>
            `<li class="list-inline-item border border-primary rounded p-2 font-weight-bold discount-code-list-item">
            ${code}
            <button type="button" class="close pl-2 remove-discount-code" 
                    aria-label="Ta bort kampanjkoden ${code}"
                    value="${code}">
                <span aria-hidden="true">&times;</span>
            </button>
        </li>`;
        const codes = payload.discountCodes.map(itemTemplate).join('');

        $('.discount-code-list ul').html(codes);
        $('.discount-code-list').toggleClass('d-none', payload.discountCodes.length === 0);
    });

    var isProcessingPurchase = false;

    function togglePurchaseButtonLoad(forceShow = true) {
        $('form#complete-purchase-form #purchase-btn-spinner').toggleClass('d-none', !forceShow);
        isProcessingPurchase = forceShow;
    }

    // submit form validation
    $('form#complete-purchase-form.needs-validation').submit((event) => {
        if (isProcessingPurchase) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        togglePurchaseButtonLoad(true);
        validateTermsConsent();
        validateForm(event);
    });

    $('form#complete-purchase-form .form-check-input').on('change', (event) => {
        if ($('form#complete-purchase-form').hasClass('was-validated')) {
            validateTermsConsent();
            event.target.checkValidity();
        }
    });

    var shippingAddressCheckBox = $(':checkbox[data-target="#shipping-address-panel"]');

    if (shippingAddressCheckBox.is(':checked')) {
        $('#shipping-address-panel').addClass('show');
    }

    shippingAddressCheckBox.on('change', (event) => {
        $('#shipping-address-panel [data-required]').attr('required', event.currentTarget.checked);
    });

    var alternateBillingAddressCheckBox = $(':checkbox[data-target="#billing-address-panel"]');

    if (alternateBillingAddressCheckBox.is(':checked')) {
        $('#billing-address-panel').addClass('show');
    }

    alternateBillingAddressCheckBox.on('change', (event) => {
        $('#billing-address-panel [data-required]').attr('required', event.currentTarget.checked);
    });

    var termsConsentCheckBox = $(':checkbox[data-terms-consent]');

    if (termsConsentCheckBox.is(':checked')) {
        $('#complete-purchase-btn').prop('disabled', false);
    }

    termsConsentCheckBox.on('change', (event) => {
        $('#complete-purchase-btn').prop('disabled', !event.target.checked);
    });

    const validateForm = (event) => {
        const $form = $(event.target);
        if ($form.get(0).checkValidity() === false) {
            togglePurchaseButtonLoad(false);
            event.preventDefault();
            event.stopPropagation();
        }
        $form.addClass('was-validated');
    };

    // term consent is checked
    const validateTermsConsent = () => {
        const $consentCheckbox = $('#consents-to-terms-check :checkbox');
        const consents = $consentCheckbox.is(':checked');
        $consentCheckbox
            .get(0)
            .setCustomValidity(
                !consents
                    ? 'Du måste godkänna Prevents villkor för att slutföra beställningen.'
                    : ''
            );
        if (!consents) {
            togglePurchaseButtonLoad(false);
        }
    };

    // when shipping address active: address, city, postcode are required
    //
});
